import { Directions } from '../ecardsPreact.constants/directions';

export const ChevronIcon = (props) => {
    const { width = 32, height = 32, className = '', direction = Directions.Left } = props;

    let iconClass = 'icon-chevron';

    // This switch is required for the css purge to work correctly
    switch (direction) {
        case Directions.Up:
            iconClass += ' icon-chevron--up';
            break;

        case Directions.Right:
            iconClass += ' icon-chevron--right';
            break;

        case Directions.Down:
            iconClass += ' icon-chevron--down';
            break;

        case Directions.Left:
        default:
            iconClass += ' icon-chevron--left';
            break;
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            class={`${iconClass} ${className}`}
            height={height}
            fill="none"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 32 32"
        >
            <path
                fill="currentColor"
                d="M22.2 5.02a84.38 84.38 0 0 1-1.87.98c-1.6.85-1.8.98-4.31 2.94a63.65 63.65 0 0 0-3.4 2.83c-.27.25-.86.82-1.32 1.28a131.52 131.52 0 0 1-2.16 2.13c-.24.26-.5.72-.6 1.1-.03.14-.05.16-.12.16-.1 0-.24.05-.26.1l-.08.32-.08.28.07.08c.04.04.07.1.07.12l.05.09c.03.03.05.07.05.1l.1.2c.1.18.1.18.23.18.12 0 .14.02.5.36a75.38 75.38 0 0 1 2.14 2.17c.37.37 1.32 1.27 1.93 1.81a82.77 82.77 0 0 1 4.11 3.91 17.85 17.85 0 0 0 2.59 2.35c.61.41.8.46 1.6.49a3.09 3.09 0 0 0 1.76-.37c.25-.2.37-.67.23-.9a1.8 1.8 0 0 0-.18-.23l-.35-.38c-.26-.29-.68-.65-1.43-1.27l-1.31-1.07c-.88-.71-2.7-2.17-3.34-2.66l-1.85-1.38-1.99-1.43a59.24 59.24 0 0 0-2.56-1.83c-.04-.03.03-.07.38-.22.24-.1.53-.23.65-.3.4-.2 1.3-1 2.88-2.49a86.04 86.04 0 0 1 4.1-3.59L20.9 8.8l1.68-1.43C23.84 6.29 24 6.14 24 5.93c0-.05-.03-.1-.1-.17a2.67 2.67 0 0 1-.18-.19c-.05-.06-.2-.15-.37-.23-.65-.3-.92-.38-1.14-.32Z"
            />
        </svg>
    );
};
